import { BasicInfo } from '@/types';

export function getLocationInfoFrom(basicInfo: BasicInfo, apiKey: string) {
  const latitude = Number(basicInfo.venue?.address?.latitude);
  const longitude = Number(basicInfo.venue?.address?.longitude);

  return {
    location: {
      venueMultilineAddress: basicInfo.venue?.address?.localizedMultiLineAddressDisplay || [],
      hasAddress: basicInfo.venue?.address !== undefined && basicInfo.venue?.address !== null,
      venueName: basicInfo.venue?.name,
      isOnlineEvent: basicInfo.isOnline || false,
      onlineEventUrl: undefined, // TODO: Add online event url
    },
    map: {
      location: {
        latitude,
        longitude,
      },
      gMapsApiKey: apiKey,
      shouldDisplayMap: hasValidCoordinates(basicInfo),
    },
  };
}

function hasValidCoordinates(basicInfo: BasicInfo) {
  const latitude = Number(basicInfo.venue?.address?.latitude);
  const longitude = Number(basicInfo.venue?.address?.longitude);

  const hasCoordinates = !!basicInfo.venue?.address?.longitude && !!basicInfo.venue?.address?.latitude;
  if (!hasCoordinates) {
    return false;
  }

  const areFiniteNumbers = Number.isFinite(latitude) && Number.isFinite(longitude);
  const hasValidLatitude = latitude >= -90 && latitude <= 90;
  const hasValidLongitude = longitude >= -180 && longitude <= 180;

  return areFiniteNumbers && hasValidLatitude && hasValidLongitude;
}
